var mrLightbox = function(container) {
  var that = this;
  var $container = $(container);
    
  $container.append('<div class="mr-lightbox-scrim"></div><div class="mr-lightbox"><div class="mr-lightbox-text"></div><div class="mr-lightbox-x">x</div></div>');
  
  $('.mr-lightbox-x, .mr-lightbox-scrim').on('click', function() {
    that.close();
  });
    
  this.open = function(div) {
    $('.mr-lightbox-scrim, .mr-lightbox').fadeIn();
    var html = $(div).html();
    $('.mr-lightbox-text').html(html);
  };
  
  this.close = function() {
    $('.mr-lightbox-scrim, .mr-lightbox').fadeOut();
    $('.mr-lightbox-text').empty();
  };
};


(function(window, $, mrLightbox){

	var app = function(){
	
		var that = this;
		this.config = { // Defaults.
      apiUrl: 'http://nmajh.e-io.org/iys/',
      apiExt: '',
      vidCt: 10,
      imgPath: 'http://iys.nmajh.org/images/iys/exact/640/360/'
    };
    
    this.settingsUrl = 'config/settings.json';
    this.versionUrl = 'config/version.json';
    this.questions = [];
    this.curSlides = [];
    this.curQuestion = {};
    this.curQuestionIndex = 0;
    this.curTag = 'all';
    this.sort = 'liked';
    this.curPage = 1;
    this.featured = false;
    this.shouldRefreshTags = true;
    this.tagType = 'question';
    this.lightbox = new mrLightbox('body');
    this.curScrollAmt = 0;
    this.curWaypoint = 0;
    this.initTriggerDist = 320;
    this.curTriggerDist = this.initTriggerDist; // First waypoint trigger is at 320px, then changes to 640.
    

    this.init = function() {
      this.getVersion();
      this.getSettings();
      this.initQuestions();
      this.initSlides();
      this.initSlider();
      this.initVideo();
      this.initTags();
      this.initDropdown();
      this.initLightbox();
      this.initLinks();
    };
    
    
    this.getSettings = function() {
      $.ajax({
        dataType: "json",
        url: that.settingsUrl,
        success: function(data) {
          log('Settings received');
          that.config = data;
        },
        error: function() {
          log('Could not retrieve settings.');
        },
        complete: function() {
          // Continue even if we have to use default settings.
          $(window).trigger('APP_SETTINGS_UPDATED');
        }
      });
    };
    
    
    this.getVersion = function() {
      $.getJSON(that.versionUrl, function(data) {
        log("version " + data.version, data.date);
      });
    };
    
    
    this.initLightbox = function() {
      $('a[rel="lightbox"]').on('click', function(e) {
        e.preventDefault();
        var div = $(this).attr('data-div');
        that.lightbox.open('.' + div);
      });
    };
    
    
    this.initDropdown = function() {
      $('ul.dropdown-menu li').on('click', that.onMenuChoose);
    };
    
    
    this.chooseQuestion = function(i) {
      this.curQuestion = this.questions[i];
      $('.q').attr('data-index', i); // Store question index in DOM.
      
      log('question changed', this.curQuestion);
      $(window).trigger('APP_QUESTION_CHANGED', [this.curQuestion]);
    };
    
    
    this.onMenuChoose = function(e) {
      log('Menu item selected', e);
      var curId = e.currentTarget.id;
      var $caret = $('.caret.tpl')
        .clone()
        .removeClass('tpl');

      // Newest: http://iys.nmajh.org/iys/28/all/recent/page-1?kiosk=false
      // Featured: http://iys.nmajh.org/iys/28/all/recent/page-1?kiosk=false&featured=true
      // Most Popular: http://iys.nmajh.org/iys/28/all/liked/page-1?kiosk=false
            
      // Figure out params for AJAX call.
      switch (curId) {
        
        case 'menu-newest':
          that.sort = 'recent';
        break;
        
        case 'menu-featured':
          that.sort = 'recent';
          that.featured = true;
        break;
        
        default:
        case 'menu-popular':
          that.sort = 'liked';        
        break;
      }

      // Replace menu title.
      $('.dropdown-toggle')
        .text(document.getElementById(curId).innerText)
        .append($caret);

      // Get new slides.
      that.tagType = 'slides';
      var q = that.getCurQuestion().id;
      that.getSlides(q, that.curTag, that.sort, that.curPage, that.featured);
      
      // Reset 'featured' setting, tagType setting.
      that.featured = false;
    };
    
    
    this.initLinks = function() {
      $('*[data-href]').each(function(i, el) {
        $(this).addClass('link')
          .on('click', function() {
          window.location = $(this).attr('data-href');
        });
      });
    };
    
    
		this.initQuestions = function() {
     
      // Listen for settings so we know the API location.
      $(window).on('APP_SETTINGS_UPDATED', function() {
        
        log('Getting questions');
        
        // Get them from the from API.
        that.getQuestions();
        
        // Bind buttons.
        $('.q-prev').on('click', function() {
          var i = $('.q').attr('data-index');
          i = i > 0 ? i - 1 : that.questions.length - 1;
          that.chooseQuestion(i);
        });
        
        $('.q-next').on('click', function() {
          var i = parseInt($('.q').attr('data-index'), 10);
          i = i < that.questions.length - 1 ? i + 1 : 0;
          that.chooseQuestion(i);
        });
        
        $(window).on('APP_QUESTION_CHANGED', function() {
          $('.q').text(that.curQuestion.text);
        });
      });
      
		};
		
		
		this.initSlides = function() {
      $(window).on('APP_QUESTION_CHANGED APP_TAG_DEACTIVATED', function(e, newQ) {
        that.getSlides(newQ.id, that.curTag, that.sort, 1);        
      })
      .on('APP_VIDEOS_RCVD', function(e, data) {
        that.curSlides = data;
        that.refreshSlides(data);       
      });
      
      $('.more').on('click', function() {
        that.curPage++;
        var q = that.getCurQuestion();
        that.getSlides(q.id, that.curTag, that.sort, that.curPage);
      });     
    };
		
		
		this.initSlider = function() {
      // Build the slider.
      // Use jQuery UI demo code with additions and slight tweak.
      var scrollPane = $( "#carousel" );
      var scrollContent = $( "#carousel-content" );
      var tags = [];
   
      var scrollbar = $( ".scroll-bar" ).slider({
        slide: function(e, ui) {
          if (scrollContent.width() > scrollPane.width()) {
            
            var scrollAmt = Math.round(ui.value / 100 * ( scrollPane.width() - scrollContent.width() ));
            scrollContent.css( "margin-left", scrollAmt + "px" );
            
            // Simulate keeping tag cloud fixed in place.
            $('.tags').css('left', -scrollAmt);
            
            // Scroll tags with custom parallax effect.
            $('.tag').each(function(i, tag) {    
              $(tag).css('marginLeft', -($(this).attr('data-parallax-ratio') * (ui.value * 3)) + 'px');
            });
            
            
            // Waypoint tag glows.
            var switchTags = false;
            //log('modulus', that.curScrollAmt % that.curTriggerDist, scrollAmt % that.curTriggerDist, that.curTriggerDist,  that.curWaypoint);
                        
            // Scrolling left.
            if (scrollAmt < that.curScrollAmt) {
              
              // Have we passed a trigger point?
              if ((that.curScrollAmt - that.initTriggerDist) % that.curTriggerDist < (scrollAmt - that.initTriggerDist) % that.curTriggerDist) {
                
                that.curWaypoint++;
                if (that.curWaypoint >= 1) {
                  that.curTriggerDist = 640;
                }
                
                switchTags = true;
              }
            
            // Scrolling right.
            } else {
              
              // Have we passed a trigger point?
              if ((that.curScrollAmt - that.initTriggerDist) % that.curTriggerDist > (scrollAmt - that.initTriggerDist) % that.curTriggerDist) {
              
                that.curWaypoint--;
                if (that.curWaypoint < 1) {
                  that.curTriggerDist = 640; // Should this be that.initTriggerDist?
                }
                
                switchTags = true;
              }
            }
            
            // Do the triggering.
            if (switchTags) {
              tags = that.getTagsToGlow();
              $(window).trigger('APP_VIDEO_ENTERED', [tags]);
            }
            
            // Update scroll amt for next pass.            
            that.curScrollAmt = scrollAmt;
            
          } else {
            scrollContent.css( "margin-left", 0 );
          }
        }
        
      });
      
      // Hide slider handle if only one video.
      $(window).on('APP_SLIDES_RENDERED', function() {
        var $handle = $('.ui-slider-handle');
        if ($('#carousel .vid-box').length == 1) {
          $handle.hide();
        } else {
          $handle.show();
        }
      });
      
		};
						
		
		/* Init video controls */
		this.initVideo = function() {
      var $vidBox = {};
     
      $('.vid-placeholder, .vid-play, video').on('click', function() { // TODO: Clicking on video.
        $vidBox = $(this).parents('.vid-box'); 
        that.playVideo($vidBox);
      });
      
      $('.vid-pause').on('click', function() {
        $vidBox = $(this).parents('.vid-box');
        that.pauseVideo($vidBox);
      });
      
      // Likes and flags.
      var storyId; 
      $('.vid-like').one('click', function() {
        // Post to http://nmajh.e-io.org/iys/stories/like with story_id.
        storyId = $(this).parents('.vid-box').attr('data-id');
        that.updateStory('like', storyId);
      });
      
      $('.vid-flag').one('click', function() {
        // Post to http://nmajh.e-io.org/iys/stories/flag with story_id.
        storyId = $(this).parents('.vid-box').attr('data-id');
        that.updateStory('flag', storyId);
      });
		};
						
		
		this.playVideo = function($vidBox) {
      var url = $vidBox.attr('data-video');
      log('playing video');
      
      // Stop all other videos.
      $('video').each(function(i) {
        var $newVidBox = $(this).parents('.vid-box');
        that.pauseVideo($newVidBox);
      });
      
      // Switch icons.  
      $vidBox.find('.vid-play')
        .hide()
        .siblings('.vid-pause')
          .show();
      
      // Swap placeholder for video if needed.          
      if ($vidBox.children('video').length === 0) {
        $vidBox
          .children('.vid-placeholder-box')
            .prepend('<video>')
            .children('video')
              .attr({
                src: url,
                autoplay: 'autoplay',
                poster: $vidBox.attr('data-poster')
              }).get(0).play();
        $vidBox.find('img.vid-placeholder').remove();
      } else {
        $vidBox.children('video').get(0).play();
      }
		};
		
		
		this.pauseVideo = function($vidBox) {
      log('pausing video');
      
      $vidBox.find('.vid-pause')
        .hide()
        .siblings('.vid-play')
          .show()
        .end()
        .parents('.vid-box')
          .find('video')
            .addClass('has-played')
            .get(0)
              .pause();
		};

		
		this.updateStory = function(action, storyId) {
		
      // POST to API.
      $.ajax({
        type: 'POST',
        url: that.config.apiUrl + 'stories/' + action,
        data: {
          story_id: storyId
        }, 
        success: function(data, status, jqXHR) {
          $thisBox = $('.vid-box[data-id=' + storyId + ']');
          
          switch (action) {
            
            case 'like':
              $thisBox
                .find('.vid-like')
                  .addClass('active')
                  .find('.ctrl-like-num')
                    .text(data)
                  .end()
                  .find('.ctrl-like-plus')
                    .show();
            break;
            
            case 'flag':
              $thisBox
                .find('.vid-flag')
                .addClass('flagged')
                .find('.ctrl-text-flag')
                  .text('Flagged');
            break;
            
            default:
            break;
          }
        }, 
        error: function(data, status, jqXHR) {
          log('Post to api failed', data, status);
        }
      });
      
		
		};
		
		
		this.initTags = function() {
      
      $(window).on('APP_SLIDES_RENDERED', function(e) {
        if (that.shouldRefreshTags) {
          that.refreshTags();
        }
        
        // Reset values.
        that.shouldRefreshTags = true;       
        that.tagType = 'question';
        
      }).on('APP_VIDEO_ENTERED APP_TAGS_RENDERED', function(e, tags){
        
        tags = typeof(tags) === "undefined"
          ? that.getTagsToGlow()
          : tags;
        
        that.glowTags(tags);
      });
      
      $('.tag-close').on('click', function(e) {
        e.stopPropagation(); // Don't pass click on to tag.
        $('.tag').removeClass('active');
        
        that.shouldRefreshTags = false;
        var curQ = that.getCurQuestion();
        $(window).trigger('APP_TAG_DEACTIVATED', [curQ]);
      });
		};
		
		
		this.getTagsToGlow = function() {
      var left = parseInt($('#carousel-content').css('margin-left'), 10);
      var $vids = [];
      var tags = [];

      // Are we scrolling?
      if(Math.abs(left) > 0) {
        var i = Math.floor(Math.abs((left - that.initTriggerDist) / 640)) + 1; 
        tags = tags.concat($('.vid-box').eq(i).attr('class').replace('vid-box ', '').split(' '));
        
      // Or are we in default position?
      } else {
        $vids = $('.vid-box:visible').slice(0,2).each(function(i ,el) {
          tags = tags.concat($(el).attr('class').replace('vid-box ', '').split(' '));
        });
      }
      
      return tags;
		};
		
		
		this.glowTags = function(tags) {
      $('.tag').removeClass('active glow');
      for (var i in tags) {
        $('.tag.' + tags[i]).addClass('glow');
      }
		};
		
		this.refreshTags = function(n) {
      var tags = [];
      var preTags = {};
      var usedTags = [];

      switch (that.tagType) {
        
        case 'slides':
          for (var i in that.curSlides) {
            for (var j in that.curSlides[i].tags) {
              var tmpTxt = that.curSlides[i].tags[j];
              preTags[tmpTxt] = 1; // Make this tag structure compatible with question-related tags.
            }
          }
        break;
        
        default:
        case 'question':
          preTags =  that.getCurQuestion().tags;
        break;
          
      }
      
      log('refreshing tags', preTags);
      
      for (var i in preTags) {
        if (usedTags.indexOf(i) === -1) { // Unique only.
          var wt = Math.floor(Math.random() * 10) + 0.1; // Weighted high.
          var tag = {
            text: i,
            weight: wt, 
            html: {
              'class': 'tag ' + i,
              'data-tag': preTags[i],
              'data-parallax-ratio': wt * 0.1
            },
            handlers: {
              'click': that.tagChosen
            }, 
            afterWordRender: function() {
              $('.tag-close.tpl')
                .clone(true, true)
                .removeClass('tpl')
                .appendTo($(this));               
            }
          };
          tags.push(tag);
          usedTags.push(i);
        }
      }
      
      var cloudOpts = {
        afterCloudRender: function() {
          $(this).css('margin-left', '-150px'); // Needs to scoot to the left.
          $(window).trigger('APP_TAGS_RENDERED');
        }, 
        center : {
          x: 0.5,
          y: 0.5
        },
        width: '1300',
        height: '345',
        //shape: 'rectangular'
      };
      
      $('.tags')
        .children('.tag')
          .remove()
        .end()
        .jQCloud('destroy')
        .jQCloud(tags, cloudOpts);
      
		};
		
		
		this.tagChosen = function(e) {
      var $chosen = $(e.currentTarget);
      var text = e.currentTarget.innerText; 
      var curQId = that.getCurQuestion().id;
      
      if (!$chosen.hasClass('active')) {
        // Change color
        $chosen
          .addClass('active')
          .siblings('.tag')
            .removeClass('active glow');
            
        // Get videos from API.
        that.shouldRefreshTags = false;
        that.getSlides(curQId, text, that.sort);
      }     
      
		};
		
		
		this.refreshSlides = function(slideData) {
      
      // Remove old videos first.
      $('.videos')
        .children('.vid-box, .more')
          .remove();
          
      // Calculate width.
      var moreWidth = 200;
      var slideWidth = 640 + 15;
      $('#carousel-content').css('width', slideData.length * slideWidth + moreWidth);
      
      // Load up the divs.
      for (var i in slideData) {
        var imgPath = that.config.imgPath + slideData[i].image_id.toString() + '.png';

        var $newVid = $('.tpl.vid-box')
          .clone(true, true)
          .removeClass('tpl')
          .attr({
            'data-video': slideData[i].path,
            'data-id': slideData[i].id,
            'data-poster': imgPath
          })
          .addClass(function() {
            return that.explodeTags(slideData[i].tags);
          })
          .find('img.vid-placeholder')
            .attr('src', imgPath)
          .end()
          .find('.ctrl-like-num')
            .text(slideData[i].likes)
          .end();
                    
        // Center it if it's the only one. 
        if (slideData.length == 1) {
          $newVid.addClass('center');
        }
          
        $newVid.appendTo('.videos');
      }
      
      // Add Load More block. 
      if (slideData.length == this.config.vidCt) {
        $('.tpl.more')
          .clone(true, true)
          .removeClass('tpl')
          .appendTo('.videos');
      } else {
        $('.more:visible').remove();
      }
      
      // Scroll everything back.
      $('#carousel-content').animate({'margin-left': '0px'});
      $('.ui-slider-handle, .tags').animate({'left': '0px'});
      
      $('.tag').each(function(i, tag) {
        $(this).animate({'margin-left': '0px'});
      });

      $(window).trigger('APP_SLIDES_RENDERED');
		};
		
		
		this.explodeTags = function(oldTags) {
      var strTags = '';
      for (var i in oldTags) {
        strTags += oldTags[i] + ' ';
      }
      return strTags;
		};
		
		
		this.getQuestions = function(tag, sort, page) {
      var allQuestions = [];
      var url = this.config.apiUrl + 'list';
      
      // Get all questions with full data first, then get 'featured' questions
      $.getJSON(url, function(data1) {
        
        log('all questions retrieved', data1);   
        
        // Make array more usable.
        for (var i in data1) {
          allQuestions[data1[i].id] = data1[i];
        }     
        
        // Now, for the featured.
        url += '?featured=true';
        $.getJSON(url, function(data2) {
        
          // Merge allQuestions data with this set
          for (var i in data2) {
            data2[i].tags = allQuestions[data2[i].id].tags;
            that.questions.push(data2[i]);
          }
          
          // Set current question
          that.chooseQuestion(0);

        }).done(function() {
          // TODO: On fail?
        });
        
      }).done(function() {
        // TODO: On fail?
      });
      
      
    };
    
    
    this.getCurQuestion = function() {
      return this.curQuestion;
    };
    
    
    this.getSlides = function(q, tag, sort, page, featured) {
      var url = this.formApiUrl(q, tag, sort, page, featured);
      
      $.getJSON(url, function(data) {
        if (data.length > 0) { // API returns empty array for unknown tags.
          $(window).trigger('APP_VIDEOS_RCVD', [data]);
        } else {
          log('API does not recognize tag.');
        }
      }).done(function() {
        // TODO: On fail?
      });
      
    };
    
    
    this.formApiUrl = function(q, tag, sort, page, featured) {
      var url = this.config.apiUrl + q;
      url = typeof(tag) !== 'undefined'
        ? url + '/' + tag
        : url;
      url = typeof(sort) !== 'undefined'
        ? url + '/' + sort 
        : url;
      url = typeof(page) !== 'undefined'
        ? url + '/page-' + page 
        : url;
			
      url = url + '?kiosk=false';
      
      url = typeof(featured) !== 'undefined'
        ? url + '&featured=' + featured 
        : url;
      
      return url;
    };

  };
  
  var iys = new app();
  iys.init();
		
})(window, $, mrLightbox);